import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2, Copy } from "lucide-react";

export default function UTMBuilder() {
  const [templates, setTemplates] = useState([]);
  const [url, setUrl] = useState("https://places-legacy-site.emergent.host/");
  const [params, setParams] = useState({ source: "", medium: "", campaign: "", content: "", term: "" });

  useEffect(() => { api.get("/content/kv/utm_templates").then(({data}) => Array.isArray(data) && setTemplates(data)); }, []);

  const build = () => {
    try {
      const u = new URL(url);
      Object.entries(params).forEach(([k, v]) => { if (v) u.searchParams.set(`utm_${k}`, v); });
      return u.toString();
    } catch { return url; }
  };

  const copyUrl = () => { navigator.clipboard.writeText(build()); toast.success("URL copiada."); };

  const saveTemplates = async () => {
    try { await api.put("/content/kv/utm_templates", { value: templates }); toast.success("Templates salvos."); }
    catch { toast.error("Erro ao salvar."); }
  };
  const updT = (i, k, v) => setTemplates(arr => { const a = [...arr]; a[i] = {...a[i], [k]: v}; return a; });
  const addT = () => setTemplates(arr => [...arr, { name: "Novo template", source: "", medium: "", campaign: "", content: "" }]);
  const removeT = (i) => setTemplates(arr => arr.filter((_, j) => j !== i));
  const applyTpl = (t) => setParams({ source: t.source || "", medium: t.medium || "", campaign: t.campaign || "", content: t.content || "", term: t.term || "" });

  return (
    <div>
      <div className="flex justify-between items-end mb-6">
        <div><h1 className="font-display text-4xl">UTM Builder</h1><p className="text-sm text-neutral-500 mt-1">Gere URLs com UTMs para suas campanhas em segundos.</p></div>
      </div>

      <section className="mb-8 border border-black/10 p-5 rounded">
        <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700 mb-3">Gerar URL</div>
        <div className="space-y-3">
          <div><label className="text-xs text-neutral-500">URL base</label><input value={url} onChange={(e) => setUrl(e.target.value)} className="w-full border border-black/15 px-3 py-2 rounded text-sm" data-testid="utm-url" /></div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
            {Object.keys(params).map(k => (
              <div key={k}>
                <label className="text-xs text-neutral-500 uppercase">utm_{k}</label>
                <input value={params[k]} onChange={(e) => setParams({...params, [k]: e.target.value})} className="w-full border border-black/15 px-2 py-1.5 rounded text-sm" data-testid={`utm-${k}`} />
              </div>
            ))}
          </div>
          <div className="bg-black text-white p-3 rounded text-xs font-mono break-all" data-testid="utm-result">{build()}</div>
          <button onClick={copyUrl} className="bg-accent-yellow text-black text-sm font-semibold px-4 py-2 rounded-full"><Copy className="w-3 h-3 inline mr-1" /> Copiar URL</button>
        </div>
      </section>

      <section className="border border-black/10 p-5 rounded">
        <div className="flex justify-between items-center mb-3"><div className="font-semibold text-sm uppercase tracking-widest text-neutral-700">Templates salvos</div>
          <div className="flex gap-2">
            <button onClick={addT} className="text-xs bg-accent-yellow px-3 py-1 rounded-full font-semibold"><Plus className="w-3 h-3 inline" /> Novo</button>
            <button onClick={saveTemplates} className="text-xs bg-black text-white px-3 py-1 rounded-full font-semibold"><Save className="w-3 h-3 inline" /> Salvar templates</button>
          </div>
        </div>
        <div className="space-y-2">
          {templates.map((t, i) => (
            <div key={i} className="grid grid-cols-12 gap-2 items-center border border-black/10 p-2 rounded" data-testid={`utm-template-${i}`}>
              <input value={t.name} onChange={(e) => updT(i, "name", e.target.value)} placeholder="Nome" className="col-span-3 border border-black/15 px-2 py-1.5 rounded text-sm" />
              <input value={t.source} onChange={(e) => updT(i, "source", e.target.value)} placeholder="source" className="col-span-2 border border-black/15 px-2 py-1.5 rounded text-sm" />
              <input value={t.medium} onChange={(e) => updT(i, "medium", e.target.value)} placeholder="medium" className="col-span-2 border border-black/15 px-2 py-1.5 rounded text-sm" />
              <input value={t.campaign} onChange={(e) => updT(i, "campaign", e.target.value)} placeholder="campaign" className="col-span-2 border border-black/15 px-2 py-1.5 rounded text-sm" />
              <input value={t.content} onChange={(e) => updT(i, "content", e.target.value)} placeholder="content" className="col-span-2 border border-black/15 px-2 py-1.5 rounded text-sm" />
              <div className="col-span-1 flex gap-1"><button onClick={() => applyTpl(t)} className="text-xs bg-black/5 px-1.5 py-1 rounded">Usar</button><button onClick={() => removeT(i)} className="text-red-500"><Trash2 className="w-3 h-3" /></button></div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
